import React, { useState } from 'react'

export const DownloadButton = ({
  width = 24,
  height = 24,
  color = '#003087',
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.9978 2C12.5501 2 12.9978 2.44772 12.9978 3L12.9978 13.5903L15.2929 11.2951C15.6834 10.9046 16.3166 10.9046 16.7071 11.2951C17.0977 11.6857 17.0977 12.3188 16.7071 12.7094L12.712 16.7045C12.3176 17.0989 11.6781 17.0989 11.2836 16.7045L7.2885 12.7094C6.89797 12.3188 6.89797 11.6857 7.2885 11.2951C7.67902 10.9046 8.31219 10.9046 8.70271 11.2951L10.9978 13.5902L10.9978 3C10.9978 2.44772 11.4455 2 11.9978 2Z"
        fill={color}
      />
      <path
        d="M3 13C3 12.4477 3.44772 12 4 12C4.55228 12 5 12.4477 5 13V19H19V13C19 12.4477 19.4477 12 20 12C20.5523 12 21 12.4477 21 13V20C21 20.5523 20.5523 21 20 21H4C3.44772 21 3 20.5523 3 20V13Z"
        fill={color}
      />
    </svg>
  )
}
